<template>
  <div class="solution1">
    <div class="banner">
      <div class="w1200">
        <h3>农业单品行业大数据解决方案</h3>
        <p>
          以农业单品行业为切入点，对供应链 进行数字化改造，最终形成农业单品
          大数据平台，助力产业升级
        </p>
      </div>
    </div>
    <div class="container">
      <img src="@/assets/mob/images/solution/c_1.jpg" alt />
    </div>
    <ul class="con">
      <li class="clear">
        <h4>柔性生产管理平台</h4>
        <p>
          汇集生产管理数据，运用技术手段进行分析，为产业发展给出指导性建议，规避流程化管理过程中的铺张浪费，实现柔性化生产
        </p>
      </li>
      <li class="clear">
        <h4>生产周边服务平台</h4>
        <p>将不同类型的服务标准化，进行精准匹配</p>
      </li>
      <li class="clear">
        <h4>产业电商平台</h4>
        <p>
          围绕产业链中核心企业，解决投入品采购和产成品销售问题，更加贴合产业，服务大宗，提供多种交易方式，支付方式和发货方式
        </p>
      </li>
      <li class="clear">
        <h4>智能物流平台</h4>
        <p>建立货源池和运力池，进行有效的车货匹配以及路径规划</p>
      </li>
      <li class="clear">
        <h4>物联网&人工智能平台</h4>
        <p>
          将人工智能与产业互联网场景化，根据行业特殊性，打造不同的人工智能应用
        </p>
      </li>
      <li class="clear mar0_b">
        <h4>供应链金融平台</h4>
        <p>整合金融服务商，形成标准化金融产品，实现产融结合</p>
      </li>
    </ul>
    <div class="d_footer">
      <div
        class="button"
        @click="
          show = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <Dialog
      :show="show"
      :systemId="systemId"
      @close="show = false"
      title="获取最新解决方案"
    />
  </div>
</template>
<script>
import Dialog from './components/dialog'
export default {
  components: { Dialog: Dialog },
  data() {
    return {
      systemId: '3',
      show: false,
    }
  },
}
</script>
<style lang="scss">
@import '~@/assets/mob/css/solution.scss';
</style>
